import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../../data/testimonials';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../ui/carousel';

export const Testimonials = () => {
  return (
    <section className="py-12 lg:py-16 bg-gradient-to-b from-white to-cream" data-testid="testimonials-section">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="font-serif text-2xl lg:text-3xl font-bold text-foreground mb-2">
            What Our <span className="text-gold">Customers</span> Say
          </h2>
          <p className="text-muted-foreground text-sm">
            Real stories from real people who transformed their lives
          </p>
        </motion.div>

        <Carousel
          opts={{
            align: 'start',
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent className="-ml-4">
            {testimonials.map((testimonial, index) => (
              <CarouselItem key={testimonial.id} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="h-full"
                  data-testid={`testimonial-${testimonial.id}`}
                >
                  <div className="h-full p-6 rounded-2xl bg-white border border-amber-100 shadow-sm hover:shadow-md transition-shadow">
                    {/* Quote Icon */}
                    <Quote className="w-8 h-8 text-gold/30 mb-4" />

                    {/* Rating */}
                    <div className="flex gap-1 mb-4">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          className={`w-4 h-4 ${
                            i < testimonial.rating
                              ? 'text-gold fill-gold'
                              : 'text-muted-foreground'
                          }`}
                        />
                      ))}
                    </div>

                    {/* Text */}
                    <p className="text-foreground mb-6 leading-relaxed text-sm">
                      "{testimonial.text}"
                    </p>

                    {/* Product */}
                    <p className="text-xs text-gold mb-4">
                      Purchased: {testimonial.product}
                    </p>

                    {/* Author */}
                    <div className="flex items-center gap-3">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-12 h-12 rounded-full object-cover border-2 border-gold/20"
                      />
                      <div>
                        <p className="font-medium text-foreground">
                          {testimonial.name}
                        </p>
                        <p className="text-xs text-muted-foreground">
                          {testimonial.location}
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="hidden md:flex justify-center gap-2 mt-8">
            <CarouselPrevious className="static translate-y-0 bg-white border-amber-200 hover:bg-gold/10 hover:border-gold hover:text-gold" />
            <CarouselNext className="static translate-y-0 bg-white border-amber-200 hover:bg-gold/10 hover:border-gold hover:text-gold" />
          </div>
        </Carousel>
      </div>
    </section>
  );
};
